<template>
    <div>
        <div class="order-userInfo">
            <div class="userInfo-wrapper" >
                <div class="userInfo-border" >
                    <h5>基本设置</h5>
                    <el-row class="userInfo-group" >
                        <el-row>
                            <el-col :span="8" class="order-item" >学校域名：<span>{{ product.content.basic_configure.cor_domain_url}}</span></el-col>
                            <el-col :span="8" class="order-item" >服务时间：<span>{{new Date(product.content.start_at).toLocaleDateString()}}-{{new Date(product.content.end_at).toLocaleDateString()}}</span></el-col>
                            <el-col :span="8" class="order-item order-logo-fix"><em>Logo：</em><span v-if="typeof product.content.basic_configure.fileList=='undefined' ||  product.content.basic_configure.fileList.length == 0" >暂无</span><span v-else v-for="logo in product.content.basic_configure.fileList" :key="logo.uid" ><img :src="logo.url" /></span></el-col>
                        </el-row>
                    </el-row>
                </div>
            </div>
            <div class="userInfo-wrapper">
                <div class="userInfo-border" >
                    <h5>额度设置</h5>
                    <div class="userInfo-group" >
                        <div class="set-wrapper" >
                            <el-row class="set-number" >
                                <div class="order-item" style="float:left; width:100px; margin-right:30px;" >日额度设置</div>
                                <el-row>
                                    <el-col :span="5" class="order-item" >
                                        总：{{product.content.limit_configure.day.all}}
                                        <span v-html="showOldConfigOther('day','all')"></span>
                                    </el-col>
                                    <el-col :span="5" class="order-item" >
                                        普：{{product.content.limit_configure.day.pu}}
                                        <span v-html="showOldConfigOther('day','pu')"></span>
                                    </el-col>
                                    <el-col :span="5" class="order-item" >
                                        精：{{product.content.limit_configure.day.jing}}
                                        <span v-html="showOldConfigOther('day','jing')"></span>
                                    </el-col>
                                    <el-col :span="5" class="order-item" >
                                        特：{{product.content.limit_configure.day.te}}
                                        <span v-html="showOldConfigOther('day','te')"></span>
                                    </el-col>
                                </el-row>
                            </el-row>
                        </div>
                        <div>
                            <el-tabs type="border-card" v-model="default_tab">
                                <el-tab-pane name="normal">
                                    <span slot="label">普通精品额度</span>
                                    <el-table v-if="product.content.limit_configure.normal.length != 0"
                                              :data="product.content.limit_configure.normal"
                                              border
                                              style="width: 100%;">
                                        <el-table-column
                                                prop="subject_name"
                                                label="科目">
                                        </el-table-column>
                                        <el-table-column label="总" prop="config.all">
                                            <template slot-scope="scope">
                                                {{scope.row.config.all}}
                                                <span v-html="showOldConfig('normal',scope.row.subject_id,'all')"></span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="精" prop="config.jing">
                                            <template slot-scope="scope">
                                                {{scope.row.config.jing}}
                                                <span v-html="showOldConfig('normal',scope.row.subject_id,'jing')"></span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="小学" prop="config.primary">
                                            <template slot-scope="scope">
                                                {{scope.row.config.primary}}
                                                <span v-html="showOldConfig('normal',scope.row.subject_id,'primary')"></span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="初中" prop="config.middle">
                                            <template slot-scope="scope">
                                                {{scope.row.config.middle}}
                                                <span v-html="showOldConfig('normal',scope.row.subject_id,'middle')"></span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="高中" prop="config.high">
                                            <template slot-scope="scope">
                                                {{scope.row.config.high}}
                                                <span v-html="showOldConfig('normal',scope.row.subject_id,'high')"></span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                                <el-tab-pane name="special">
                                    <span slot="label">特供额度</span>
                                    <el-table v-if="product.content.limit_configure.special.length != 0"
                                              :data="product.content.limit_configure.special"
                                              border
                                              style="width: 100%;">
                                        <el-table-column
                                                prop="subject_name"
                                                label="科目">
                                        </el-table-column>
                                        <el-table-column label="总" prop="config.all">
                                            <template slot-scope="scope">
                                                {{scope.row.config.all}}
                                                <span v-html="showOldConfig('special',scope.row.subject_id,'all')"></span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="小学" prop="config.primary">
                                            <template slot-scope="scope">
                                                {{scope.row.config.primary}}
                                                <span v-html="showOldConfig('special',scope.row.subject_id,'primary')"></span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="初中" prop="config.middle">
                                            <template slot-scope="scope">
                                                {{scope.row.config.middle}}
                                                <span v-html="showOldConfig('special',scope.row.subject_id,'middle')"></span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="高中" prop="config.high">
                                            <template slot-scope="scope">
                                                {{scope.row.config.high}}
                                                <span v-html="showOldConfig('special',scope.row.subject_id,'high')"></span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </div>
            </div>
            <div class="userInfo-wrapper" >
                <div class="userInfo-border" >
                    <h5>版本绑定</h5>
                    <div>
                        <el-table
                            :data="product.content.version_bind"
                            border
                            style="width: 97%; margin:0 20px;">
                            <el-table-column
                                prop="subject"
                                label="学科"
                                width="100px">
                            </el-table-column>
                            <el-table-column label="绑定版本">
                                <template slot-scope="scope">
                                        <!-- 对应版本 -->
                                        <div v-if="typeof scope.row.version == 'undefined' || scope.row.version.length == 0" >---</div>
                                        <div v-else v-for="(versionBind,index) in scope.row.version" :key="index" class="version-gap" >
                                            {{versionBind.stage_name}}：<span v-for="(name,index) in versionBind.version_bind_name" :key="index">{{name}}</span>
                                        </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div class="userInfo-wrapper" >
                <div class="userInfo-border" >
                    <h5>应用绑定</h5>
                    <div>
                        <el-table
                        :data="product.content.app_bind">
                            <el-table-column
                                prop="app_name"
                                label="应用名称">
                            </el-table-column>
                            <el-table-column
                                label="推荐">
                                <template slot-scope="scope" >
                                    <span>{{scope.row.is_recommend ? "是" : "否"}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div class="userInfo-wrapper" >
                <div class="userInfo-border" >
                    <h5>模块绑定</h5>
                    <div>
                        <el-table
                        :data="product.content.module_bind">
                            <el-table-column
                                prop="mudule_name"
                                label="模块名称">
                            </el-table-column>
                            <el-table-column
                                label="展示">
                                <template slot-scope="scope" >
                                    <span>{{scope.row.is_recommend ? "是" : "否"}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import CustomerService from "~/services/customer";
export default {
    props: {
        product: {
            type: Object
        }
    },
    data(){
        return {
            configUsed:false,
            oldConfig:'',
            default_tab: 'normal',
        }
    },
    created(){
        this.getOrder();
    },
    methods:{
        getOrder() {
            CustomerService.product_config({product_code:this.product.product_code,customer_id:this.product.customer_id}).then(res => {
               this.oldConfig = res.data;
            })
        },
        showOldConfig(status,subject_id,type){
            if(typeof this.oldConfig.limit_configure !="undefined" && this.oldConfig.limit_configure[status].length>0){
                let item = this.oldConfig.limit_configure[status].find(i=>{return i.subject_id == subject_id });
                if(!item) return "";
                let oldItem = this.product.content.limit_configure[status].find(i=>{return i.subject_id == subject_id });
                if(oldItem.config[type]==item.config[type]) return "";
                return "<span  style='color: #f5222d'>原来:"+item.config[type]+"</span>";
            }
            return "";
        },

        showOldConfigOther(type,need){
            if(typeof this.oldConfig.limit_configure != "undefined"){
                    if(this.product.content.limit_configure[type][need] == this.oldConfig.limit_configure[type][need]) return "";
                return "<span  style='color: #f5222d'>原来:"+this.oldConfig.limit_configure[type][need]+"</span>";
            }
            return "";
        }



    }
}
</script>


// WEBPACK FOOTER //
// src/views/order/products/jbzyk.vue